<template lang="html">
  <v-tooltip bottom>
    <template v-slot:activator="{ on, attrs }">
      <span v-bind="attrs" v-on="on">
        <v-icon class="rounded primary white--text pa-1 mr-2">
          {{icon}}
        </v-icon>
      </span>
    </template>
    <span>{{text}}</span>
  </v-tooltip>
</template>

<script>
export default {
  name: 'FunctionIcon',
  props: {
    icon: {},
    text: {}
  }
}
</script>

<style lang="css" scoped>
</style>
